import { mapState } from 'vuex';
import accountSocialAvatar from '@/components/account/account-social-avatar/account-social-avatar.vue';
import socialLevelMixin from '@/mixins/socialLevel';

export default {
  mixins: [
    socialLevelMixin,
  ],
  components: {
    accountSocialAvatar,
  },
  computed: {
    ...mapState('user', ['watchedUserDetails']),
    userLevel() {
      if (this.watchedUserDetails.traderLevel) {
        return this.getLevelByNumber(this.watchedUserDetails.traderLevel);
      }
      return this.getLevelByPredictions(this.watchedUserDetails.profitablePredictions);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/social/user-profile-overview/user-profile-overview.js